import { decimalToDuration } from '../../../../utils/dateUtil';

enum DurationFormat {
  HOURS_AND_MINUTES = 'hh:mm',
}

type Props = {
  value: number;
  column: {
    cellParams: {
      format?: DurationFormat;
    };
  };
};

export const DurationCell = (props: Props) => {
  const { value, column } = props;
  const durationFormat =
    DurationFormat[column?.cellParams?.format] ??
    DurationFormat.HOURS_AND_MINUTES;

  return (
    <div style={{ textAlign: 'right' }}>
      {decimalToDuration(value).toFormat(durationFormat)}
    </div>
  );
};
